import { useState } from "react";

// First-run explainer helper: remembers (in localStorage) that the operator
// dismissed a one-time note, so it stays hidden on return. Returns
// [dismissed, dismiss].
export function useDismissed(storageKey) {
  const [dismissed, setDismissed] = useState(() => {
    try {
      return localStorage.getItem(storageKey) === "1";
    } catch (_) {
      return false;
    }
  });

  const dismiss = () => {
    setDismissed(true);
    try {
      localStorage.setItem(storageKey, "1");
    } catch (_) {
      /* ignore */
    }
  };

  return [dismissed, dismiss];
}
